import { ReactElement } from 'react';
import React from 'react';
import { TotalItem } from 'devextreme-react/data-grid';
import { conditionalTwoDigitSummaryCurrency } from './constants/constants';

interface IDrawManualTotalItemsProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
    toggleArray: [];
}

export const DrawManualTotalItems = ({
    drawId,
    drawNumber,
    drawFinalized,
    toggleArray,
}: IDrawManualTotalItemsProps): ReactElement[] => {
    if (toggleArray[drawNumber] === true) {
        return [
            <TotalItem
                name={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            <TotalItem
                name={`drawItems-funded-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            <TotalItem
                name={`drawItems-inspection-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-inspection-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            // <TotalItem
            //     name={`OutOfBalance${drawId}-${drawNumber}`}
            //     showInColumn={`OutOfBalance${drawId}-${drawNumber}`}
            //     summaryType='custom'
            //     customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            // />,
        ];
    } else {
        if (drawFinalized) {
            return [
                <TotalItem
                    name={`drawItems-funded-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
                />,
            ];
        } else {
            return [
                <TotalItem
                    name={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
                />,
            ];
        }
    }
};
